<template>
  <span>
    <uploadDialog
      v-if="showUploadEL"
      ref="uploadDialog"
      :upload-info.sync="uploadInfo"
      :file-index.sync="fileIndex"
      :total-size.sync="totalSize"
      @cancelUpload="cancelUpload"
      @closeUploadEL="closeUploadEL"
    />
    <!--confirm-->
    <co-confirm
      v-model="showConfirm"
      :content="content"
      @sure="closeConfirm"
      @close="closeConfirm"
    />
  </span>
</template>
<script>

import _$ from 'js/api/getdata.js'
import uploadDialog from 'components/business/link/upload/upload-dialog'
import coConfirm from 'components/common/confirm/index.vue'
import coButton from 'components/common/button/index.vue'
import { getLanguage } from 'js/util/util'

const { upload } = require('js/api/getdata').default

export default {

  components: {
    uploadDialog,
    coConfirm,
    coButton,
  },
  data() {
    return {
      showConfirm: false,
      content: '',
      progressInfo: [],
      dataId: 0, // 上传列表文件数据索引
      showUploadEL: false,
      uploadInfo: [],
      axiosList: [],
      fileList: [], // 所有显示文件的列表
      fileListLen: 0, // 所有文件的数量
      fileIndex: 0, // 上传的下标
      lockList: [], // 上传失败或者不符合要求的文件下标
      warnTxt: [],
      totalSize: 0, // 所有文件的大小
      toCloseUploadEl: false,
      // 上传需要的一些数据
      data: {
        deliveryCode: '',
        token: '',
        neid: '',
        upload_url: '',
        curPath: '',
      },

    }
  },
  methods: {
    /**
             * 校验每一条数据的权限
             */
    async checkAuth(d) {
      // 拼接url
      const tmp = []
      for (const i in d.data) {
        if (d.data[i]) {
          tmp.push(`${i}=${d.data[i]}`)
        }
      }
      let url = _$.formatUrl(`/delivery/auth_upload/${d.deliveryCode}`)
      url += `?${tmp.join('&')}`
      const da = await _$.getUrl(url)
      return da
    },
    /**
             * 上传前的权限验证
             * 先校验，校验完后统一处理上传
             */
    async authUpload(files, option) {
      // 初始化参数
      this.data = option
      let tempFileIndex = 0

      // 文件数量的校验
      if (files.length > 100) {
        this.content = this.$t('对不起，一次最多只能添加100个文件！')
        this.showConfirm = true
        this.clearFileInput()
        return
      }

      if (this.fileListLen > 0) {
        tempFileIndex = this.fileListLen
      }
      this.fileListLen += files.length

      // 格式化数据
      for (let x = 0, len = files.length; x < len; x++) {
        const i = tempFileIndex > 0 ? tempFileIndex + x : x

        if (files[x].size > 1073741824) {
          files[x].warnTxt = '目前不支持上传大于1G的文件'
          this.lockList.push(i)
        }

        if (files[x].size == 0) {
          files[x].warnTxt = '您选择了一个空文件'
          this.lockList.push(i)
        }
        this.totalSize += files[x].size

        // 格式化数据给每一个数据每一个file对象
        const startTime = new Date().getTime()// 当前上传动作开始时间
        const o = { file: files[x], startTime, path: this.data.curPath }
        // o = JSON.parse(JSON.stringify(o));
        this.fileList.push(o)
        this.uploadInfo.splice(0, 1, this.fileList)

        const afterCheckAuth = (dataId) => {
          if (dataId === this.fileListLen - 1) { // 文件信息全部存入待操作列表后，进行上传操作
            let asyncCount // 上传请求最大并发数,并发数量过大时IE在上传过程中会卡住
            if (!!window.ActiveXObject || 'ActiveXObject' in window || window.navigator.userAgent.indexOf('MSIE') > -1) { // IE浏览器
              asyncCount = 2
            } else {
              asyncCount = 6
            }
            asyncCount = files.length >= asyncCount ? asyncCount : files.length
            for (let count = 0; count < asyncCount; count++) {
              this.fileIndex = tempFileIndex == 0 ? count : tempFileIndex
              this.uploadFile(tempFileIndex)// 上传文件
            }
          }
          if (x === files.length - 1) this.clearFileInput()
        }

        // 处理每一条数据
        const data = {
          deliveryCode: this.data.deliveryCode,
          data: {
            filename: files[x].name,
            token: this.data.token || '',
            bytes: files[x].size,
            neid: this.data.neid,
          },
        }
        // 校验数据是否可上传
        try {
          /* eslint-disable */
                        await this.checkAuth(data)
                        afterCheckAuth(this.dataId++)
                    } catch (e) {
                        if (e && e.response.data && e.response.data.message) {
                            let err = e.response.data;
                            this.fileList[i].file.warnTxt = err.message;
                            this.fileList[i].file.error = true;
                            this.uploadInfo.splice(0, 1, this.fileList)
                        }
                        this.lockList.push(i)
                        afterCheckAuth(this.dataId++)
                    }
                }
            },
            /**
             * 关闭确认弹出框
             */
            closeConfirm() {
                this.showConfirm = false;
                if (this.toCloseUploadEl) {
                    this.cancelUpload('all')
                    this.toCloseUploadEl = false;
                    this.showUploadEL = false;
                    this.axiosList = [];
                    this.uploadInfo = [];
                }
            },
            /**
             * 清空input 内容
             */
            clearFileInput() {
                this.$emit('reset')
            },
            /**
             * 格式化url
             */
            formatUrl(file) {
                let url = this.data.upload_url + '&overwrite=true&source=link&language=' + getLanguage();
                url = url.replace(/\{([^\}]+)\}/g, function (s0, s1) {
                    return file.name;
                });
                url = encodeURI(url);
                url = url.replace(/#/g, '%23');
                return url;
            },
            /**
             * 上传文件
             * @asyncCount 上传请求最大并发数
             */
            uploadFile(asyncCount){
                let fileData = new FormData(),
                    index = asyncCount || this.fileIndex,
                    currentFileInfo = this.fileList[index];
                if (!currentFileInfo) return;

                fileData.append('file', currentFileInfo.file);

                this.showUploadEL = true

                let vm = this;
                this.$nextTick(() => {//上传弹窗最大化
                    if (vm.$refs.uploadDialog && vm.$refs.uploadDialog.minDialog) {
                        vm.$refs.uploadDialog.minDialog = false;
                        vm.$refs.uploadDialog.hasCancel = false;
                    }
                })

                if (this.lockList.indexOf(index) > -1) {
                    this.fileList[index].file.error = true;
                    this.uploadInfo.splice(0, 1, this.fileList)
                    return;
                }

                //拼接URL
                let urlTail = this.formatUrl(currentFileInfo.file);

                // eslint-disable-next-line guard-for-in
                if (currentFileInfo.file) {
                    //将所执行的上传操作存到一个数组里
                    let o = this.uploadAction(urlTail, index, fileData, currentFileInfo.startTime)
                    this.axiosList.push(o)
                } else {
                    // 需要处理一个报错信息=======================
                    currentFileInfo.warnTxt = '目前不支持上传大于1G的文件';
                    this.lockList.push(index)
                }
            },
            /**
             * 上传操作，以及上传的进度
             */
            uploadAction(url,index, fileData, startTime) {
                let progress = (progressEvent) => {
                    let currentTime = new Date().getTime(),
                        speed = (progressEvent.loaded / 1024) / ((currentTime - startTime) / 1000),//计算当前速度,单位(KB/S)
                        loaded = progressEvent.loaded,//当前剩余量
                        // remainTime = Math.round((remain / 1024) / speed);//当前剩余时间
                        remainInfo = {speed, loaded}
                    //存入当前执行条目信息
                    this.fileList[index] = Object.assign({}, this.fileList[index],{progressEvent})
                    this.fileList[index] = Object.assign({}, this.fileList[index],{remaining: remainInfo})
                    this.uploadInfo.splice(0, 1, this.fileList)
                }
                let vm = this,
                    fn = upload(url, fileData, progress),
                    actionList = fn.action.then((res) => {
                        if (res.status === 200) {
                            vm.afterUpload()
                        }
                    }).catch(function (error){
                        let isCatch = true;
                        vm.afterUpload(isCatch);
                        if(error.toString().indexOf('Network Error') > -1) {
                            vm.fileList[index].file.warnTxt = '网络连接异常，上传失败';
                            vm.$refs.uploadDialog.dialogTitle = '上传失败';
                            for (let i = index, len = vm.fileList.length; i < len; i++) {
                                vm.fileList[i].file.warnTxt = '网络连接异常，上传失败';
                            }
                            vm.$refs.uploadDialog.hasCancel = true;
                            vm.uploadInfo.splice(0, 1, vm.fileList)
                        }
                    });
                return {actionList, source: fn.source};
            },
            /**
             * 上传之后的回调
             */
            afterUpload(catchVal = false) {
                if (!catchVal && this.fileIndex < this.fileListLen) {
                    ++this.fileIndex;//每执行一次后文件索引递增
                    this.uploadFile();//继续上传
                }
                this.$refs.uploadDialog.dialogTitle = '正在上传';
                if (this.fileIndex === this.fileListLen) this.completeUpload(); //上传完成后更新文件列表
            },
            /**
             * 取消上传
             */
            cancelUpload(index) {
                let checkCancelFn = (i) => {
                    if (this.axiosList[i] && this.axiosList[i].source) {
                        this.axiosList[i].source.cancel(i);
                        this.axiosList[i] = null
                        this.afterUpload()
                    }
                    this.lockList.push(i);
                }
                /* eslint-disable */
                if (index === 'all') {//取消全部
                    for (let i in this.fileList) {
                        checkCancelFn(i)
                    }
                } else {
                    checkCancelFn(index)
                }
                this.completeUpload()
            },
            /**
             * 关闭上传框
             */
            closeUploadEL() {
                if (this.$refs.uploadDialog.dialogTitle !== '已完成') {
                    this.content = this.$t('确认取消所有未完成的任务？');
                    this.showConfirm = true;
                    this.toCloseUploadEl = true;
                    return;
                }
                this.toCloseUploadEl = false;
                this.showUploadEL = false;
                this.uploadInfo = [];
            },
            /**
             * 上传完成之后
             */
            completeUpload(){
                this.$refs.uploadDialog.dialogTitle = '已完成';
                this.$refs.uploadDialog.minDialog = true;
                let vm = this, timer;
                clearTimeout(timer)
                // 重新刷新列表
                timer = setTimeout(()=>{
                    vm.$emit('after-upload')
                },300)
            }
        },
        mounted() {
            let vm = this;
            window.onbeforeunload = function (e) {
                e = e || window.event;
                if (vm.$refs.uploadDialog && vm.$refs.uploadDialog.dialogTitle !== '已完成') {
                    if (e) {
                        e.returnValue = vm.$t('上传正在进行中，是否离开当前页？');
                    }
                    return vm.$t('上传正在进行中，是否离开当前页？');
                }
            };
        },
    }
</script>
